import { FC, useMemo, useState } from 'react'
import moment from 'moment'
import { Button } from '../../../components/Button'
import { Spinner } from 'featureSliced/entities/Spinner'
import { RenderIf } from '../../../components/RenderIf'
import { useTranslations } from '../../shared/hooks/useTranslations'
import { handleLocalStorage } from '../../shared/utils/handleLocalStorage'
import { useMySelector } from '../../shared/hooks/useMySelector'
import { getEarliestPickup } from '../../shared/utils/getEarliestPickup'
import { Calendar } from '../../../components/Calendar'
import { SelectContainer } from './styledComponents'
import { SelectTime } from './styled'

type TimePickerProps = {
  increaseStep?: () => void
}

export const TimePicker: FC<TimePickerProps> = ({ increaseStep }) => {
  // Hooks
  const t = useTranslations()
  const { isAppInit } = useMySelector((state) => state.app)
  const { leadTimeDays, leadTimeHours } = useMySelector(
    (state) => state.app.clickCollectConfig
  )
  const { restaurants } = useMySelector((state) => state)

  const earliest = useMemo(
    () =>
      getEarliestPickup({
        now: moment(),
        leadTimeDays,
        cutoff: leadTimeHours,
        schedules: (restaurants ?? []).map((restaurant) => restaurant.schedule),
      }),
    [leadTimeDays, leadTimeHours, restaurants]
  )

  // State
  const [dateTime, setDateTime] = useState(earliest.defaultSlot)

  // Functions
  const handleAccept = () => {
    if (!dateTime.isValid()) return
    handleLocalStorage({
      pickUpTime: dateTime.clone().utc().format(),
    })
    increaseStep?.()
  }

  return (
    <SelectContainer>
      <SelectTime>{t('clickCollect.choosePickUpTime')}</SelectTime>
      <RenderIf condition={isAppInit}>
        <Calendar
          key={earliest.defaultSlot.valueOf()}
          showTime
          minDate={earliest.minDate}
          defaultValue={earliest.defaultSlot}
          onUpdate={setDateTime}
        />
        <Button buttonType="common" width="100%" onClick={handleAccept}>
          {t('buttons.accept')}
        </Button>
      </RenderIf>
      <RenderIf condition={!isAppInit}>
        <Spinner type="alternate" />
      </RenderIf>
    </SelectContainer>
  )
}

export default TimePicker
